import {
    createApp
} from 'vue'
import App from './App.vue'
// 
import './assets/iconfont.css'
import router from './router'
import store from './store'
import 'vant/lib/index.css';
import Vant from 'vant';
import 'vant/lib/index.less';
import {
    postJson,
    postQuery
} from './assets/js/axios'
const app = createApp(App);
app.config.globalProperties.$postJson = postJson;
app.config.globalProperties.$postQuery = postQuery;
import NavBar from '@/components/NavBar'
app.component("NavBar", NavBar);
app.use(store).use(router).use(Vant).mount('#app');